import React from 'react';
import DataSourceConfiguration from './DataSourceConfiguration';

interface CETConfigurationProps {
    configuration: {
        // IDataSourceConfiguration Members
        SourceType?: string;
        Configuration?: string;
    };
    onChange: (field: string, value: string | number | boolean) => void;
    disabled?: boolean;
}

interface CETConfigurationComponent extends React.FC<CETConfigurationProps> {
    configFields: string[];
}

const CETConfiguration: CETConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <DataSourceConfiguration 
                configuration={{
                    SourceType: configuration.SourceType || '',
                    Configuration: configuration.Configuration || '{}'
                }}
                onChange={onChange}
                disabled={disabled}
            />
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
CETConfiguration.configFields = [
    'SourceType',
    'Configuration'
];

export default CETConfiguration;
